var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon logo",
    height: "100%",
    viewBox: "0 0 329 179",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1171.51,-5619.74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1335.9,5702.32L1282.85,5619.74L1171.51,5793.07L1179.85,5798.42L1282.85,5638.07C1282.85,5638.07 1330.01,5711.48 1330.01,5711.48C1330.01,5711.48 1277.61,5793.07 1277.61,5793.07L1285.94,5798.42L1335.9,5720.65C1335.9,5720.65 1385.86,5798.42 1385.86,5798.42L1394.19,5793.07L1341.79,5711.48C1341.79,5711.48 1388.95,5638.07 1388.95,5638.07L1491.95,5798.42L1500.29,5793.07L1388.95,5619.74L1335.9,5702.32Z",
    style: {
      fill: "currentColor"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.aaec28d112d9f7a8ac1e69fbe106aaf2.svg";
export { ForwardRef as ReactComponent };